import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoPin = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Pin</title>
    <path
      d="M6.666 22.32a5.333 5.333 0 0 1 5.333-5.334h8a5.334 5.334 0 0 1 5.334 5.333v0c0 .737-.597 1.334-1.333 1.334H8a1.333 1.333 0 0 1-1.334-1.334v0ZM16 23.653v6.667M12 7.652h8l1.333 9.334H10.666l1.333-9.334ZM22.368 6.915a1.333 1.333 0 0 1-1.192.737H10.823c-.505 0-.966-.285-1.192-.737l-.667-1.333a1.333 1.333 0 0 1 1.193-1.93h11.685a1.333 1.333 0 0 1 1.193 1.93l-.667 1.333Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoPin;
